// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wolink[data-v-422d29a8] {\n  display: inline;\n  float: right bottom;\n  flex-direction: row;\n  white-space: nowrap;\n}\n.icon[data-v-422d29a8] {\n  float: right;\n  white-space: normal;\n  margin-top: 5px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
